import React, { Component } from 'react';
import Tools  from './ChildComponents/Tools';
import Content from './ChildComponents/Content';
import Engraving from './ChildComponents/Engraving';
import ErrorBoundary from './ErrorBoundary';
import './style/fonts.css';

class App extends Component {
  render() {
    return (
      <div>
        <div className='Container'>
          <ErrorBoundary>
            <div className='ContainerChild tools'>
              <Tools  />
            </div>
            <div  id='content' className='ContainerChild content-options'>
              <Content />
            </div>
            <div className='ContainerChild engraving'>
              <Engraving  />
            </div>
          </ErrorBoundary>
        </div>
      </div>
    );
  }
}

export default App;
